import { fetchApi } from '@/config/axiosSetting';
import {
  GetBodyCustomerDocumentImagesQueryParamsType,
  GetBodyCustomerDocumentImagesQueryResponseType,
} from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyCustomerDocumentImages/getBodyCustomerDocumentImagesQuery.type';

export const getBodyCustomerDocumentImagesQueryFunction = (
  params: GetBodyCustomerDocumentImagesQueryParamsType,
): Promise<GetBodyCustomerDocumentImagesQueryResponseType[]> => {
  return fetchApi.get(`/body/reports/${params.id}/images/customer/document/`);
};
